// Where keyboard focus goes when a docked chat opens (Lane 1390): the message box, or,
// when the chat shows no message box (it failed to load and offers Try again), its first
// button. The chat bubble hides while the chat is open, so focus must land inside it.
export default function focusChat(scope) {
  if (!scope) return;
  const target = scope.querySelector('.wchat-textarea') || scope.querySelector('button');
  if (target) target.focus();
}
